import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
    Popconfirm,
    message, AutoComplete,
} from 'antd';
const FormItem = Form.Item;
import {actions, asyncGet, deleteALL, asyncGetAppv, asyncGetAll,asyncGetAPPList} from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }
    componentDidMount() {
        this.props.asyncGetAppv();
    }
    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncGet();
        this.props.asyncGetAppv();
    }
    sendCommend = () => {
        // 下发命令
        this.props.asyncGetAll();
        this.props.editShow({ isSendCommend: true });
    }
    setGroup = () => {
        this.props.editShow({ isSetGroupShow: true });
    }
    udpateVersion = () =>{
        this.props.editShow({ udpateVersionShow: true });
    }
    udpateAPPList = () =>{
        this.props.editShow({ udpateAppListShow: true });
        this.props.asyncGetAPPList();
    }
    deleteALL = () => {
        const { transferData } = this.props;
        const { selectedRowKeys = [] } = transferData;
        if (selectedRowKeys.length) {
            this.props.deleteALL({clientIdList: selectedRowKeys})
                .then(() => {
                    this.props.getTransferData({ selectedRowKeys: [] });
                    this.props.asyncGet();
                });
        } else {
            message.error('请选择需要删除的客户端');
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>客户端列表</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="设备ID">
                                {getFieldDecorator('clientIds')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="分组ID">
                                {getFieldDecorator('groupId')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="架子ID">
                                {getFieldDecorator('shelfId')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="群控版本">
                                {getFieldDecorator('appvs')(
                                   // <Input placeholder="请填写" style={{ width: '100%' }} />
                                /*    <AutoComplete
                                        allowClear
                                        placeholder="全部"
                                        style={{ width: 160 }}
                                        dataSource={this.props.listAppv.map((item, index) => {
                                            return (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            );
                                        })}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    />,*/
                                    <Select
                                        mode="multiple"
                                        style={{ width: '100%' }}
                                        placeholder="请输入"

                                        style={{ width: 160 }}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >{this.props.listAppv.map((item, index) => {
                                        return (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}</Select>
                                    )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="状态" {...spans}>
                                {getFieldDecorator('onLine')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value='1'>
                                            在线
                                        </Option>
                                        <Option key='2' value='2'>
                                            掉线
                                        </Option>
                                        <Option key='3' value='0'>
                                            下架
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="类型" {...spans}>
                                {getFieldDecorator('os')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value={'ios'}>
                                            ios
                                        </Option>
                                        <Option key='2' value={'android'}>
                                            android
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Button type="danger" onClick={this.sendCommend} style={{ margin: '0 8px' }}>
                                下发命令
                            </Button>
                            <Button style={{ margin: '0 8px' }} onClick={this.setGroup} style={{ margin: '0 8px' }}>
                                设置分组
                            </Button>
                            <Popconfirm
                                title='确认删除'
                                okText='确定'
                                cancelText='取消'
                                onConfirm={() => {
                                    this.deleteALL();
                                }}>
                                <Button type="danger" style={{ marginRight: '5px' }}>
                                    批量删除
                                </Button>
                            </Popconfirm>
                            <Button style={{ margin: '0 8px' }} onClick={this.udpateVersion} style={{ margin: '0 8px' }}>
                                批量更新目标版本
                            </Button>
                            <Button style={{ margin: '0 8px' }} onClick={this.udpateAPPList} style={{ margin: '0 8px' }}>
                                批量更新APP
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    listAppv: state.clientList.listAppv,
});
const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: params => dispatch(actions.changeUiStatus(params)),
    deleteALL: data => dispatch(deleteALL(data)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    asyncGetAppv: () => dispatch(asyncGetAppv()),
    asyncGetAll: () => dispatch(asyncGetAll()),
    asyncGetAPPList: () => dispatch(asyncGetAPPList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/client/clientList/search.js